import { render, staticRenderFns } from "./init.vue?vue&type=template&id=2f174758&scoped=true"
import script from "./init.vue?vue&type=script&lang=js"
export * from "./init.vue?vue&type=script&lang=js"
import style0 from "./init.vue?vue&type=style&index=0&id=2f174758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f174758",
  null
  
)

export default component.exports